import {useState} from 'react';
import {useAuth} from '../auth';
import {capacityState} from '../utils';
import {Icon} from './Icon';

/**
 * État de session unique : ce que je peux faire maintenant, pourquoi, et l'action pour en sortir.
 * Remplace les deux pastilles permanentes de la barre et `MutationReadiness`.
 */
export function Capacity({compact = false}: {compact?: boolean}) {
  const {me, authTimeMs, reauthenticate} = useAuth();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  if (!me) return null;
  const state = capacityState(me.policy, authTimeMs);

  return <div className={`capacity ${state.tone}${compact ? ' compact' : ''}`}>
    <span className="cap-title"><Icon name={state.ready ? 'check' : 'lock'} size={14} /> {state.title}</span>
    <ul className="cap-list">
      {state.checks.map(check => <li key={check.label} className={check.ok ? 'ok' : 'ko'}><Icon name={check.icon} size={12} /> {check.label}</li>)}
    </ul>
    {state.canReauthenticate && <button type="button" className="btn sm" aria-expanded={open} onClick={() => setOpen(value => !value)}>Réauthentifier</button>}
    {open && <form className="inline-form" onSubmit={async event => {
      event.preventDefault(); setBusy(true);
      try { await reauthenticate(password); setPassword(''); setOpen(false); }
      catch { /* Le contexte affiche l'erreur Firebase. */ }
      finally { setBusy(false); }
    }}>
      <label>Mot de passe<input type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></label>
      <button disabled={busy}>{busy ? 'Vérification…' : 'Continuer'}</button>
    </form>}
    {state.needsMfaEnrolment && <p className="cap-help">Reconnectez-vous avec un compte déjà inscrit à la MFA. L’inscription et le contournement MFA ne sont pas disponibles ici.</p>}
  </div>;
}

/** Vrai quand les actions sensibles sont autorisées ; sinon le portail reste en lecture. */
export function useCapacity() {
  const {me, authTimeMs} = useAuth();
  return me ? capacityState(me.policy, authTimeMs) : null;
}

export const readOnlyReason = 'Lecture seule : un e-mail vérifié et une authentification récente sont requis.';
